import { render, staticRenderFns } from "./ProductUnit.vue?vue&type=template&id=09ec7bce&scoped=true&"
import script from "./ProductUnit.vue?vue&type=script&lang=js&"
export * from "./ProductUnit.vue?vue&type=script&lang=js&"
import style0 from "./ProductUnit.vue?vue&type=style&index=0&id=09ec7bce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ec7bce",
  null
  
)

export default component.exports